module.exports = __webpack_public_path__ + "img/avatar3.700dd952.png";